import { createSelector } from 'reselect';

const selectVehicleCategories = (state: any) => state.vehicleCategories;


export const selectVehicleCategoriesCurrentItem = createSelector([selectVehicleCategories], (vehicleCategories) => vehicleCategories.current);

export const selectVehicleCategoriesListItems = createSelector([selectVehicleCategories], (vehicleCategories) => vehicleCategories.list);

export const selectVehicleCategoriesItemById = (itemId: any) =>
    createSelector(selectVehicleCategoriesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectVehicleCategoriesQueryItems = createSelector([selectVehicleCategories], (vehicleCategories) => vehicleCategories.query);

export const selectVehicleCategoriesCreatedItem = createSelector([selectVehicleCategories], (vehicleCategories) => vehicleCategories.create);

export const selectVehicleCategoriesUpdatedItem = createSelector([selectVehicleCategories], (vehicleCategories) => vehicleCategories.update);

export const selectVehicleCategoriesReadItem = createSelector([selectVehicleCategories], (vehicleCategories) => vehicleCategories.read);

export const selectVehicleCategoriesDeletedItem = createSelector([selectVehicleCategories], (vehicleCategories) => vehicleCategories.delete);

export const selectVehicleCategoriesSearchedItems = createSelector([selectVehicleCategories], (vehicleCategories) => vehicleCategories.search);

export const selectVehicleCategoriesItemsCount = createSelector([selectVehicleCategories], (vehicleCategories) => vehicleCategories.count);

export const selectVehicleCategoriesItemsFilter = createSelector([selectVehicleCategories], (vehicleCategories) => vehicleCategories.filter);